// iconClassMap.ts
export const iconClassMap: Record<string, string> = {
  'icon-user': 'fa-user',
  'icon-check': 'fa-check',
  'icon-home': 'fa-house',
  'icon-refresh': 'fa-rotate-right',
  'icon-times': 'fa-times',
  'icon-trash-can': 'fa-trash-can',
  'icon-pen': 'fa-pen',
  'icon-plus': 'fa-plus',
  'icon-star': 'fa-star',
  'icon-bond': 'fa-money-bill',
  'icon-cash': 'fa-sack-dollar',
  'icon-credit-card': 'fa-credit-card',
  'icon-trend-up': 'fa-arrow-trend-up',
  'icon-piggy-bank': 'fa-piggy-bank',
  'icon-pension': 'fa-person-cane',
  'icon-legacy': 'fa-hands-holding-child',
  'icon-dream': 'fa-plane-departure',
  'icon-secure-family': 'fa-shield-heart',
  'icon-nudge': 'fa-lightbulb',
  'icon-lumpsum': 'fa-coins',
  'icon-line-chart': 'fa-chart-line',
  'icon-warning': 'fa-circle-info',
  'icon-info': 'fa-circle-info',
  'icon-inform': 'fa-circle-info',
  'icon-success': 'fa-circle-check',
  'icon-close': 'fa-xmark',
  'icon-leverage': 'fa-scale-unbalanced',
  'icon-error': 'fa-triangle-exclamation',
  'icon-bars': 'fa-bars',
  'icon-download': 'fa-download',
  'icon-upload': 'fa-upload',
  'icon-down-arrow': 'fa-chevron-down',
  'icon-up-arrow': 'fa-chevron-up',
  'icon-paper-plane': 'fa-paper-plane',
  'icon-less-than': 'fa-less-than',
  'icon-greater-than': 'fa-greater-than',
  'icon-calendar': 'fa-calendar',
  'icon-chevron-right': 'fa-chevron-right',
  'icon-arrow-left': 'fa-arrow-left',
  'icon-sun': 'fa-sun',
  'icon-sea-level': 'fa-water',
};
